import { useEffect, useRef, useState } from "react";
import { SpinWheel } from "../../../components/spinthewheel/SpinWheel";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import { UsePrizes } from "../../../api/campaigns/Prizes/usePrizes";
import { Loader } from "../../../components/loader/Loader";
import Button from "../../../components/button/Button";
import { AnimatePresence } from "framer-motion";
import { FullModal } from "../../world/rmc/modals/fullModal";
import clsx from "clsx";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ClaimPrizeModal } from "../../../components/modals/ClaimPrizeModal";
import { useGetSpinTheWheel } from "../../../api/getSpinthewheel";

export const SpinTheWheel = () => {
  const {
    getPrizes,
    loading,
    storeAudiencePrizes,
    setStoreAudiencePrizes,
    submittingPrizes,
    prizes,
    storePrizes,
  } = UsePrizes();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { loading: spinning, getSpinTheWheel, data } = useGetSpinTheWheel();

  const [spins, setSpins] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClaimed, setIsClaimed] = useState(false);
  const navigate = useNavigate();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    getPrizes();
    getSpinTheWheel(id);
  }, []);

  const maxSpins = 3;

  // REFRESH LOGIC
  useEffect(() => {
    const claimedWasShowing = sessionStorage.getItem("claimedActive");
    const gameWasActive = sessionStorage.getItem("spinGameActive");

    // If claimed modal was showing during refresh, navigate to home
    if (claimedWasShowing === "true") {
      sessionStorage.removeItem("spinGameActive");
      sessionStorage.removeItem("claimedActive");
      navigate("/home", { replace: true });
      return;
    }

    // If game was being played during refresh, go back
    if (gameWasActive === "true") {
      sessionStorage.removeItem("spinGameActive");
      sessionStorage.removeItem("claimedActive");
      navigate(-1, { replace: true });
      return;
    }
  }, []);

  //Track if game is active (has spins in progress)
  useEffect(() => {
    if (spins > 0) {
      sessionStorage.setItem("spinGameActive", "true");
    } else {
      sessionStorage.removeItem("spinGameActive");
    }
  }, [spins]);

  // Track if claim modal/state is active
  useEffect(() => {
    if (isClaimed) {
      sessionStorage.setItem("claimedActive", "true");
    } else {
      sessionStorage.removeItem("claimedActive");
    }
  }, [isClaimed]);

  // const segments = [
  //   {
  //     segmentText: "TRY AGAIN",
  //     segColor: "#2741D6",
  //     textColor: "white",
  //     imageUrl: "/image/C1.png",
  //   },
  //   {
  //     segmentText: "2000 AIRTIME",
  //     segColor: "#E6E6E6",
  //     textColor: "black",
  //   },
  //   {
  //     segmentText: "50% OFF",
  //     segColor: "#2741D6",
  //     textColor: "white",
  //   },
  //   {
  //     segmentText: "MOVIE TICKET",
  //     segColor: "#E6E6E6",
  //     textColor: "black",
  //   },
  //   {
  //     segmentText: "500 AIRTIME",
  //     segColor: "#2741D6",
  //     textColor: "white",
  //   },
  //   {
  //     segmentText: "FREE BOTTLE",
  //     segColor: "#E6E6E6",
  //     textColor: "black",
  //   },
  // ];

  // Function to map API data to segments
  const mapApiDataToSegments = (apiData) => {
    if (!apiData || !Array.isArray(apiData)) return [];

    return apiData.map((item) => ({
      segmentText: item.label_text,
      segColor: item.background_color,
      textColor: item.label_color === "#00000" ? "#000000" : item.label_color, // Fix incomplete hex color
      imageUrl: item.icon,
      probability: parseFloat(item.probability),
      id: item.id,
      spin_the_wheel_id: item.spin_the_wheel_id,
    }));
  };

  const segments = data?.data?.spin_the_wheel_segments
    ? mapApiDataToSegments(data.data.spin_the_wheel_segments)
    : [];

  const handleSpinFinish = (wonSegmentText) => {
    if (spins >= maxSpins) return;

    const wonSegment = segments.find(
      (segment) => segment.segmentText === wonSegmentText
    );

    if (
      wonSegment &&
      wonSegment.id &&
      wonSegment.spin_the_wheel_id &&
      (wonSegment.segmentText.toLowerCase() !== "try again" ||
        wonSegment.segmentText.toLowerCase() !== "better luck next spin!")
    ) {
      // Find matching prize by name
      const matchingPrize = prizes.find(
        (prize) =>
          prize.name.toLowerCase() === wonSegment.segmentText.toLowerCase()
      );

      if (matchingPrize) {
        setStoreAudiencePrizes((prev) => [...prev, matchingPrize.name]);
      }
    }

    const newSpinCount = spins + 1;
    setSpins(newSpinCount);
  };

  const spinWheelProps = {
    segments,
    maxSpins: maxSpins,
    spins: spins,
    onFinished: handleSpinFinish,
    primaryColor: "white",
    contrastColor: "#2741D6",
    buttonText: "",
    isOnlyOnce: false,
    size: 150,
    upDuration: 300,
    downDuration: 600,
    fontFamily: "Arial",
    fontSize: "12px",
    arrowLocation: "bottom",
    showTextOnSpin: true,
    isSpinSound: true,
  };

  if (loading || spinning) {
    return (
      <div className="h-[40dvh] flex items-center justify-center">
        <Loader type="spinningBubbles" color="#fff" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-start">
      <p className="text-center text-white text-[15px] font-medium max-w-[310px] mb-4 mx-auto">
        Here’s a chance to Spin & Win Big! Hit ‘Play’ below & spin for your
        lucky price!
      </p>
      <div className="">
        <SpinWheel {...spinWheelProps} />
        <div className="">
          <div className="w-full max-w-[320px] mt-0.5 px-4">
            <div className="mb-2 flex justify-between text-white text-sm font-medium">
              <span>Spins Used</span>
              <span>
                {spins} / {maxSpins}
              </span>
            </div>
          </div>
          <ProgressBar level={spins} max={maxSpins} />
        </div>

        <div className="mt-3 space-y-5 max-w-[340px] mx-auto">
          {spins < maxSpins ? (
            <p className="text-center text-white text-sm">
              Complete all {maxSpins} spins and win to claim your prize(s)
            </p>
          ) : (
            <>
              {storeAudiencePrizes?.length > 0 ? (
                <Button
                  onClick={async () => {
                    const isSuccess = await storePrizes(
                      data?.data?.id,
                      storeAudiencePrizes,
                      spins
                    );
                    if (isSuccess) {
                      setIsClaimed(true);
                    }
                  }}
                  className={clsx(
                    submittingPrizes && "!py-0",
                    "!w-full !bg-green-600 hover:!bg-green-700 transition-all"
                  )}
                  text={
                    submittingPrizes ? (
                      <Loader type="bubbles" />
                    ) : (
                      "Claim My Prize "
                    )
                  }
                  disabled={submittingPrizes}
                />
              ) : (
                <div className="bg-white/10 rounded-lg p-5 mb-4 max-w-[290px]">
                  <p className="text-yellow-300 text-center font-bold text-xl mb-3 ">
                    😔 Sorry!
                  </p>
                  <p className="text-white text-center text-base">
                    You didn't win anything this time. Better luck next time!
                  </p>
                </div>
              )}
            </>
          )}
          <Button
            disabled={submittingPrizes}
            onClick={async () => {
              if (spins > 0) {
                if (storeAudiencePrizes.length > 0) {
                  setIsModalOpen(true);
                } else {
                  const isSuccess = await storePrizes(
                    data?.data?.id,
                    storeAudiencePrizes,
                    spins
                  );
                  if (isSuccess) {
                    setIsClaimed(true);
                  }
                }
              } else {
                navigate(-1);
              }
            }}
            className="!w-full !bg-gray-600 hover:!bg-gray-700"
            text="Exit"
          />
        </div>
      </div>
      <AnimatePresence>
        {isModalOpen && (
          <FullModal
            className={clsx(
              "h-[400px] fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] 480:max-w-[440px] 480:mx-auto rounded-t-[20px] overflow-hidden"
            )}
            onClose={() => {
              setIsModalOpen(false);
            }}
          >
            <div className="py-8 px-6 bg-white h-full flex flex-col">
              <div
                onClick={() => setIsModalOpen(false)}
                className="bg-[#4B5563] w-[50px] rounded-[5px] h-[6px] grid place-self-center mb-6 cursor-pointer"
              ></div>

              <div className="text-center my-8">
                <h2 className="text-xl font-semibold text-primary-black">
                  Exit Game?
                </h2>
                <p className="text-base text-gray-700 mt-2">
                  Are you sure you want to leave without claiming your prize?
                </p>
              </div>

              {/* ✅ Buttons */}
              <div className="mt-auto flex flex-col gap-3 w-full">
                <Button
                  text={
                    submittingPrizes ? (
                      <Loader height="22px" width="22px" type="bubbles" />
                    ) : (
                      "Yes, Exit"
                    )
                  }
                  onClick={async () => {
                    const isSuccess = await storePrizes(
                      data?.data?.id,
                      storeAudiencePrizes,
                      spins
                    );
                    if (isSuccess) {
                      setIsClaimed(true);
                    }
                  }}
                  className="w-full"
                />
                <Button
                  className="!shadow-none logout_cancel border border-[#000000] !text-primary-black"
                  text="No, Stay & Claim"
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                />
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
      <AnimatePresence>{isClaimed && <ClaimPrizeModal />}</AnimatePresence>
    </div>
  );
};
